import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Page } from '../app/AppShell.js';
import { useAuth } from '../lib/auth.js';
import { useSos } from '../lib/sos.js';
import { HOME_TILES } from '../lib/simpleMode.js';

/**
 * The Akarya Box home (docs/box/PLAN.md A.7): one tap to each place, and the
 * first tile opens the camera to add a screen. No numbers, no charts.
 */
export function BoxHomeScreen(): ReactNode {
  const { user } = useAuth();
  const { sos } = useSos();

  return (
    <Page title="Home">
      <div className="box-home">
        {HOME_TILES.map((tile, i) => (
          <Link key={tile.to} className={i === 0 ? 'box-tile primary' : 'box-tile'} to={tile.to}>
            <strong>{tile.label}</strong>
            <span>{tile.to === '/sos' && sos?.active ? 'On now — tap to clear' : tile.hint}</span>
          </Link>
        ))}
      </div>
      {user?.name ? <p className="faint small">Signed in as {user.name}</p> : null}
    </Page>
  );
}
